/**
 * SandboxBanner — Thin fixed strip at the very top of the viewport.
 * Matches the style of the offline/online connectivity banner.
 * Does not affect layout — uses fixed positioning outside the flex flow.
 */

import { useBranding } from '@/contexts/BrandingContext';
import { AlertTriangle } from 'lucide-react';

export default function SandboxBanner() {
  const { isSandbox, sandboxExpiresAt } = useBranding();

  if (!isSandbox) return null;

  let daysRemaining: number | null = null;
  if (sandboxExpiresAt) {
    const expires = new Date(sandboxExpiresAt);
    daysRemaining = Math.max(0, Math.ceil((expires.getTime() - Date.now()) / (1000 * 60 * 60 * 24)));
  }

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[9998] bg-amber-500 text-white px-4 py-1.5 text-center text-xs font-medium"
      role="status"
    >
      <div className="flex items-center justify-center gap-1.5">
        <AlertTriangle className="w-3.5 h-3.5 flex-shrink-0" />
        <span>
          SANDBOX ENVIRONMENT — Demo instance with sample data
          {daysRemaining !== null && (
            <span className="ml-1 font-bold">
              · {daysRemaining}d remaining
            </span>
          )}
        </span>
      </div>
    </div>
  );
}
